import * as React from "react";
import { forwardRef } from "react";
const SvgPlusBook = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1008 1008", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M216 0h720v1008H216c-79 0-144-65-144-144V144C72 65 137 0 216 0zm648 792V72H360v720h504zM216 72c-40 0-72 32-72 72v696c36-54 86-48 144-48V72h-72zm18 864h630v-72H234c-20 0-36 16-36 36s16 36 36 36z" }));
const ForwardRef = forwardRef(SvgPlusBook);
export default ForwardRef;
